module.exports = __webpack_public_path__ + "img/w3_chevron_down_black.8197cfb8.8197cfb8.png";